import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_dry-wall-pro/artifacts/80dqipfj_logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Startseite", path: "/" },
    { name: "Leistungen", path: "/leistungen" },
    { name: "Referenzen", path: "/referenzen" },
    { name: "Kontakt", path: "/kontakt" },
    { name: "Impressum", path: "/impressum" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md border-b border-[#c9b9a9]" style={{ backgroundColor: '#dbcebe' }} data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Bastian Ebbecke Trockenbau Logo" 
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-semibold transition-colors hover:text-amber-600 ${
                  isActive(item.path) 
                    ? "text-amber-600" 
                    : "text-[#372d24]"
                }`}
                data-testid={`nav-${item.name.toLowerCase()}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Section */}
          <div className="hidden md:flex items-center gap-4">
            <a 
              href="tel:+491621608568" 
              className="flex items-center gap-2 text-[#372d24] hover:text-amber-600 transition-colors"
              data-testid="phone-link"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">+49 162 1608568</span>
            </a>
            <Link to="/kontakt">
              <Button 
                className="bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-md px-6"
                data-testid="cta-button"
              >
                Termin vereinbaren
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#372d24]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#c9b9a9] mobile-menu-enter" data-testid="mobile-nav">
            <nav className="flex flex-col gap-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm font-medium py-2 ${
                    isActive(item.path) 
                      ? "text-amber-600" 
                      : "text-[#372d24]"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`mobile-nav-${item.name.toLowerCase()}`}
                >
                  {item.name}
                </Link>
              ))}
              <a 
                href="tel:+491621608568" 
                className="flex items-center gap-2 text-[#372d24] py-2"
              >
                <Phone className="h-4 w-4" />
                <span className="text-sm font-medium">+49 162 1608568</span>
              </a>
              <Link to="/kontakt" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-md">
                  Termin vereinbaren
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
